<template>
    <Content>
        <h2>{{ product.phrase }}</h2>
        <h1>{{ product.name }}</h1>
        <p>{{ product.description }}</p>
        <img
            v-if="product.path_image"
            :src="$pathFilesSystem+'/'+product.path_image"
            :alt="product.name"
            @click.prevent="goToLink"
        />
        <PrimaryButton
            v-if="!product.path_image"
            type="button"
            @click.prevent="goToLink"
        >
            Acessar
        </PrimaryButton>
    </Content>
</template>

<script>
import { PrimaryButton } from "../../../components/Styles/Extends/styled";
import { Content } from "./style";

export default {
    name: "QuizResultPage",
    props: {
        product: {
            required: true
        }
    },
    components: {
        Content,
        PrimaryButton
    },
    methods: {
        goToLink() {
            window.location.href = this.product.url_redirect;
        }
    }
};
</script>
